import { type FileUploadObj, type UploadStatus } from '../../index';
import { FileUploadList } from './styles';
import { FileUploadRow } from './components/FileUploadRow/FileUploadRow';

export const FileUploadRowsContainer = ({
  files,
  uploadStatus,
  handleRemoveFile,
}: {
  files: FileUploadObj[];
  uploadStatus: Record<string, UploadStatus>;
  handleRemoveFile: (fileId: string) => void;
}) => {
  const isSingleRow = files.length === 1;

  return (
    <FileUploadList>
      {files.map((file, index) => {
        const isLastRow = index === files.length - 1;

        return (
          <FileUploadRow
            handleRemoveFile={handleRemoveFile}
            key={file.id}
            fileObj={file}
            hideDivider={isLastRow || isSingleRow}
            uploadStatus={uploadStatus[file.id]}
          />
        );
      })}
    </FileUploadList>
  );
};
